<template>
  <div class="cherkizovo-card-part-top">
    <div
      v-for="partIndex in 3"
      :key="partIndex"
      class="cherkizovo-card-part-top__col"
    >
      <div class="cherkizovo-card-part-top__label">{{ partLabels[partIndex] }}</div>
      <element-scale-part-single-table-column
        :scope="scope"
        :disabled="!isFieldAvailableForEdit(scope.row, 'scale.current_part_id')"
        :initial="partIndex === 1"
        :part-name="'part_' + partIndex"
        @save-current_part_id="saveCurrentPart(scope, $event)"
      />
    </div>
  </div>
</template>

<script>
import { ElementPropTableColumn } from '@/mixins/elementPropTableColumn';
import ElementScalePartSingleTableColumn from '@/componentsCompany/cherkizovo/tableColumnTemplates/card/parts/ElementScalePartSingleTableColumn.vue';

export default {
  name: 'cherkizovo-card-part-top',
  components: { ElementScalePartSingleTableColumn },
  mixins: [ElementPropTableColumn],
  props: {
    scope: { type: Object, required: true },
  },
  data() {
    return {
      partLabels: {
        1: 'Уровень 1 (канал, направление)',
        2: 'Уровень 2 (площадка, регион)',
        3: 'Уровень 3 (сегмент, продукт)',
      },
    };
  },
  methods: {
    saveCurrentPart(scope, chosenPartId) {
      this.saveElementPropChange(scope.row, 'scale', { current_part_id: chosenPartId });
    },
  },
};
</script>

<style scoped lang="scss">
.cherkizovo-card-part-top {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;

  &__col {
    display: flex;
    flex-direction: column;
    gap: 4px;

    // Select fills available column width
    :deep(.el-select) {
      width: 100%;
    }
  }

  &__label {
    font-size: 11px;
    font-weight: 500;
    color: #909399;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 0;
  }
}
</style>
